import { MultiStepEditSection } from "components/MainSectionTemplate/MultiStepEditSectionTemplate";
import React from "react";
import { GoogleCalendarFormState, NewExternalCalendarStep } from "./model";
import { SelectGoogleCalendar } from "./SelectGoogleCalendar";

export const googleCalendarConnectSection = (
  googleCalendarFormState: GoogleCalendarFormState,
  setGoogleCalendarFormState: (state: GoogleCalendarFormState) => void,
  peekGoogleCalendarUrl: string,
): MultiStepEditSection<NewExternalCalendarStep> => ({
  getNextSection: () => "googleCalendarConfigure",
  getPrevSection: () => "chooseCalendarType",
  isLastStep: () => false,
  sectionSteps: [{
    title: RESX.ConnectedAccount.Connect,
    isActive: true,
  }, {
    title: RESX.GeneralLabels.Configure,
    isActive: false,
  }],
  section: {
    type: "regular",
    key: "googleCalendarConnect",
    title: RESX.ExternalCalendar.NewExternalCalendar,
    fields: [{
      key: "type",
      label: RESX.GeneralLabels.Type,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        Google Calendar
      </div>,
    }, {
      key: "calendar",
      label: RESX.DateTime.Calendar,
      renderEditNew: () => <SelectGoogleCalendar
        validatorKey="selectGoogleCalendar"
        selectedCalendarId={googleCalendarFormState.googleCalendarId}
        setSelectedCalendarId={id => setGoogleCalendarFormState({ ...googleCalendarFormState, googleCalendarId: id })}
        peekGoogleCalendarUrl={peekGoogleCalendarUrl}
        onOutcomeChange={outcome => setGoogleCalendarFormState({
          ...googleCalendarFormState,
          name: outcome.data.calendarName,
          eventCount: outcome.data.eventCount,
        })}
      />
    }]
  }
});